<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div class="anything">
    <div class="w">
      <Row class="component-title pb-56px">
        <Col span="24">我要存样本</Col>
        <Col span="24" class="component-description">
          涵盖各类生物样本的低温存储
        </Col>
      </Row>
      <Row class="anything-content">
        <Col
          v-for="item in achievements"
          :key="item.id"
          span="12"
          class="h-full content2"
        >
          <div
            class="anything-content-box w-full h-full relative overflow-hidden"
            :style="`background-image: url(${item.image});`"
          >
            <div class="w-full h-full anything-detail absolute pin-b pin-l">
              <div class="detail-text h-full">
                <div class="title">{{ item.title }}</div>
                <div>
                  {{ item.content }}
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'anythingComponent',
  props: {},
  mixins: [],
  components: {},
  data() {
    return {
      achievements: [
        {
          id: 'a-1',
          title: '存储设备',
          content: '冰箱（-80℃）、液氮罐、常温密集柜',
          link: '',
          image: '/static/images/background/storage2.png'
        },
        {
          id: 'a-2',
          title: '样本类型',
          content:
            '血液、尿液、粪便、指甲及头发、唾液及口腔细胞、母乳、脑脊液、关节腔液、组织、DNA等',
          link: '',
          image: '/static/images/background/storage3.png'
        }
      ]
    }
  },
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.anything {
  background-color: #fafafa;
  padding-bottom: 2.6vw; //50px;
  .ivu-btn {
    padding: 0.73vw 1.1vw; //14px 21px;
    font-size: 0.73vw;
    line-height: 1.43;
    color: #3aa69f;
    border-radius: 5px;
    border: 1px solid #3aa69f;
    transition: all 1s;
    -moz-transition: all 1s;
    -webkit-transition: all 1s;
    -o-transition: all 1s;
    &:hover {
      color: $c-white;
      background-color: #3aa69f;
    }
  }
  .component-title {
    padding: 2.97vw 0 0.42vw 0; //57px 0 8px 0;
  }
  .anything-content {
    // height: 426px;
    padding-bottom: 3.125vw; //60px;
  }
  .anything-content-title {
    padding: 1.82vw 0 1.5625vw 0; //35px 0 30px 0;
    font-size: 1.5625vw; //30px;

    color: #111a2e;
  }
  .anything-content-box {
    background-image: url('/static/images/background/anything1.png');
    background-size: auto 16.77vw; //322px;
    background-repeat: no-repeat;
    background-position: top center;
    border-radius: 5px;
    transition: all 1s;
    -moz-transition: all 1s;
    -webkit-transition: all 1s;
    -o-transition: all 1s;
    &:hover,
    &.active {
      box-shadow: 0px 0.47vw 1.25vw rgba(168, 168, 168, 0.25); //0px 9px 24px rgba(168, 168, 168, 0.25);
      z-index: 1;
    }
  }

  .anything-detail {
    height: 7.55vw; //145px;
    border: 0 none;
    padding: 1.25vw 1.67vw 0 1.67vw; //24px 32px 0 32px;
    background-color: $c-white;
    position: absolute;
    border-radius: 0 0 5px 5px;

    transition: all 1s;
    -moz-transition: all 1s;
    -webkit-transition: all 1s;
    -o-transition: all 1s;
  }
  .detail-text {
    color: #646a77;
    font-size: 1.04vw; //20px;

    .title {
      color: #111a2e;
      font-size: 1.17vw; //22.5px;
      line-height: 1.3;
      margin-bottom: 0.42vw; //8px;
    }
  }

  .content2 {
    padding-right: 0;
    height: 24.27vw; //466px;
  }

  .pb-56px {
    padding-bottom: 2.92vw; //56px;
  }
}
</style>
